import { EMAIL_REGULAR_EXPRESSION } from '../../constants';

const validateEmail = (email) => {
  if (!email || !email.length) return false;
  const emailPattern = new RegExp(EMAIL_REGULAR_EXPRESSION);
  return emailPattern.test(email);
};

export default validateEmail;
